import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function SiteLayout() {
  return <div className="min-h-screen flex flex-col bg-club-canvas" data-id="element-292">
      <Header data-id="element-293" />
      <main className="flex-grow" data-id="element-294">
        <Outlet data-id="element-295" />
      </main>
      <Footer data-id="element-296" />
    </div>;
}